<p class="text-neutral-n6 text-center py-15 m-0">
  © 2016-{{ currentYear }} TelQ Telecom GmbH. All rights reserved.
  <br />
  TelQ® is a registered trademark of TelQ Telecom GmbH, registered in Germany and other countries.
</p>
